import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import Table from "@/components/Table";
import { t } from "i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import ProductDialog from "./ProductDialog";

const Product = () => {
  const [apiData, setApiData] = useState<any>([]);
  const { get } = ApiService;
  const { usuario } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const columns = [
    {
      header: t("table.licenca.head.produto"),
      accessor: "nomeProduto",
    },
    {
      header: t("table.product.datetime"),
      accessor: "dataHoraCadastro",
    },
    {
      header: t("table.product.status"),
      accessor: "status",
    }
  ];

  const allowedActions = [];
  if (checkHasPermission(usuario?.permissoes, "ROLE_PRODUTO_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_PRODUTO_DELETAR")) {
    allowedActions.push("remover");
  }

  const canAddNewProduct = checkHasPermission(usuario?.permissoes, "ROLE_PRODUTO_REGISTRAR");

  const fetchProducts = async () => {
    try {
        const { data } = await get("api/v1/produto/listar");
        const formatted = data.map((item: any) => ({
            ...item
        }));
        setApiData(formatted);
    } catch (error) {
        console.error("Erro ao buscar produtos", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleCreate = () => {
    setSelectedProduct(null);
    setIsModalOpen(true);
  };

  const handleEdit = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  return (
    <div className="flex-1 overflow-hidden p-8 max-md:px-4">
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t("ProductPage.title")}</h1>
      </div>
      
      <ProductDialog 
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        productToEdit={selectedProduct}
        onSuccess={fetchProducts}
      />

      {apiData && (
        <Table
          entity="produto"
          baseRoute="api/v1/produto"
          allowedActions={allowedActions}
          search={true}
          columns={columns}
          defaultData={apiData}
          buttonLabel={t("table.product.btn.add")}
          onButtonClick={handleCreate} 
          isButtonDisabled={!canAddNewProduct}
          onEditAction={handleEdit} 
          onRefresh={fetchProducts}
        />
      )}
    </div>
  );
};

export default Product;